import GoogleTagManager from "@redux-beacon/google-tag-manager";
import { createMiddleware } from "redux-beacon";
import eventsMapper from "../analytics/eventsMapper";

export default createMiddleware(eventsMapper, GoogleTagManager());
